import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Redirect } from 'react-router';
export default function HomePage() {
    return _jsx(Redirect, { to: `/login` + window.location.hash });
}
